import React, { useEffect, useState } from "react";
import { Button, Alert, Upload } from "antd";
import { Form, Input, message, Space } from "antd";
import { useDrawer } from "../../../context/drawer";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { PlusOutlined } from "@ant-design/icons";

import { useBranchDetailsMutation } from "../../../services/userAuthAPI";
import { useSelector } from "react-redux";
const { TextArea } = Input;

export default function UpdateBranches() {
  const { drawerData, toggleDrawer } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState();
  const [updateImage, setUpdateImage] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [branchDetail] = useBranchDetailsMutation();
  const [contentUpdate, setContentUpdate] = useState();

  const [imgError, setImgError] = useState({ message: null, status: null });

  // ================= Check Image Size ===================
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/avif";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG/AVIF file!");
      setImgError({
        message: "You can only upload JPG/PNG file!",
        status: true,
      });
    } else {
      setImgError({
        message: null,
        status: false,
      });
    }
    const isLt2M = file.size / 1024 < 300;
    if (!isLt2M) {
      message.error("Image size larger that 300KB please re-upload");
      setImgError({
        message: "Image size larger that 300KB please re-upload",
        status: true,
      });
    } else {
      setImgError({
        message: null,
        status: false,
      });
    }
    return isJpgOrPng && isLt2M;
  };

  // ========================= Update Submit ==============
  const [form] = Form.useForm();
  const { token } = useSelector((state) => state.auth);

  //   ============================== Call Update API ========================
  const onFinish = async (values) => {
    try {
      const formData = new FormData();
      formData.append("id", values.id);
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      if (updateImage) {
        formData.append("branch_img", fileList[0].originFileObj);
      }
      formData.append("address", values.address);
      formData.append("branchtime", values.branchtime);
      formData.append(
        "branch_slug",
        values.name.toLowerCase().split(" ").join("-")
      );
      formData.append("action", "update");
      formData.append("token", token);

      setLoading(true);

      const response = await branchDetail(formData);
      if (response.data) {
        setLoading(false);
        form.resetFields();
        toggleDrawer();
        message.success("Submit success!");
      }
    } catch (error) {
      setLoading(false);
      message.error("Add failed!");
      // Handle errors
      console.error("Error making POST request", error);
    }
  };
  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    const phoneRegex = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;

    if (phoneRegex.test(input)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  //   ====================== Image Upload =======================
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setUpdateImage(true);
  };

  console.log(fileList);

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  //   =================== File Check =================
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  //   ====================== Data Set ===================

  useEffect(() => {
    if (drawerData.value !== null) {
      form.setFieldsValue({
        id: drawerData.value.id,
        branch_img: drawerData.value.emp_img,
        name: drawerData.value.name,
        phone: drawerData.value.phone,
        email: drawerData.value.email,
        address: drawerData.value.address,
        branchtime: drawerData.value.branchtime,
      });
    }
    // eslint-disable-next-line
  }, [drawerData]);

  return (
    <div className="drawerForm">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item label="Id" name="id" style={{ display: "none" }}>
          <Input />
        </Form.Item>
        {imgError.status && <Alert message={imgError.message} type="error" />}
        <Form.Item
          label="Upload Image"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          name="branch_img"
        >
          <Upload
            // action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
            listType="picture-card"
            fileList={fileList}
            onChange={handleChange}
            beforeUpload={beforeUpload}
            accept=".jpeg, .jpg, .png, .avif"
            maxCount={1}
          >
            {uploadButton}
          </Upload>
        </Form.Item>

        <Form.Item
          name="name"
          label="Branch Name"
          style={{
            margin: "3px 4px",
          }}
          hasFeedback
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Full Name" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Branch Phone"
          style={{
            display: "inline-block",
            width: "calc(50% - 8px)",
            margin: "3px 4px",
          }}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please enter a phone number!",
            },
          ]}
        >
          <Input
            placeholder="e.g., (555) 555-5555"
            addonBefore="+1"
            onChange={handleInputChange}
          />
          {!isValid && (
            <p style={{ color: "red" }}>
              Please enter a valid phone number.
            </p>
          )}
        </Form.Item>
        <Form.Item
          name="email"
          label="Branch Email ID"
          style={{
            display: "inline-block",
            width: "calc(50% - 8px)",
            margin: "3px 4px",
          }}
          hasFeedback
          rules={[
            {
              required: true,
            },
            {
              type: "email",
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="address"
          label="Branch Address"
          hasFeedback
          style={{
            margin: "3px 4px",
          }}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <TextArea
            showCount
            maxLength={150}
            style={{
              height: 100,
              resize: "none",
            }}
            placeholder="Address"
          />
        </Form.Item>
        <Form.Item
          name="branchtime"
          label="Branch Times"
          style={{
            margin: "3px 4px",
          }}
          hasFeedback
          rules={[
            {
              required: true,
            },
          ]}
        >
          <ReactQuill
            theme="snow"
            value={contentUpdate}
            onChange={setContentUpdate}
          />
        </Form.Item>

        <Form.Item style={{ marginTop: "20px" }}>
          <Space>
            <Button type="primary" loading={loading} htmlType="submit">
              Submit
            </Button>
            <Button danger onClick={toggleDrawer}>
              Cancel
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
}
